






























import { getMessageById } from '@/utils/message';
import Vue, { PropType } from 'vue';

export enum EcharGroup {
  non = 'non',
  num = 'num',
  alphanum = 'alphanum',
  half = 'half',
}

declare interface IMethods {
  onInput: (value: string) => void;
  onBlur: (value: string) => void;
}

declare interface IComputed {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inputRules: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  displayCounter: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  skipTab: any;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default Vue.extend<any, IMethods, IComputed, any>({
  name: 'CtrlNormalText',
  props: {
    label: { required: false, type: String, default: '' },
    required: { required: false, type: Boolean },
    placeholder: { required: true, type: String },
    charGroup: { required: true, type: String as PropType<EcharGroup> },
    length: { required: true, type: Number },
    inputDigitDisplay: { type: Boolean, default: false },
    value: { required: false, type: [String, Number], default: '' },
    appendRules: { required: false, type: Array, default: () => [] },
    showToolTip: { required: false, type: Boolean, default: false },
    // mw-10, mw-20....
    maxWidth: { type: String },
    textAlign: { required: false, type: String, default: 'left' },
  },

  data() {
    return {
      textValue: '',
      id: '',
      rules: {
        counter: (value: string) => {
          return (
            (value || '').toString().length <= this.length ||
            `${getMessageById('KI_W010')} ${this.length}`
          );
        },
        required: (value: string) => !!value || getMessageById('KI_W007'),
      },
    };
  },

  watch: {
    value(val) {
      if (val != null) {
        this.textValue = val;
      }
    },
  },

  computed: {
    inputRules() {
      return this.required
        ? [this.rules.counter, this.rules.required, ...this.appendRules]
        : [this.rules.counter, ...this.appendRules];
    },
    displayCounter() {
      // High prioty
      if (
        'readonly' in this.$attrs &&
        (this.$attrs.readonly === '' ||
          this.$attrs.readonly === 'true' ||
          this.$attrs.readonly)
      ) {
        return false;
      }

      return this.inputDigitDisplay ? this.length : false;
    },
    skipTab() {
      if (
        'readonly' in this.$attrs &&
        (this.$attrs.readonly === '' ||
          this.$attrs.readonly === 'true' ||
          this.$attrs.readonly)
      ) {
        return -1;
      }
      return 0;
    },
  },
  methods: {
    onInput(value: string) {
      let newValue = '';

      switch (this.charGroup) {
        case EcharGroup.num:
          newValue = value.replace(/[^0-9]/g, '');
          break;

        case EcharGroup.alphanum:
          newValue = value.replace(/[^a-zA-Z0-9]/g, '');
          break;

        case EcharGroup.half:
          newValue = value.replace(/[^a-zA-Z0-9ｧ-ﾝﾞﾟ!-/:-@¥[-`{-~]/g, '');
          break;

        default:
          newValue = value;
          break;
      }

      const self = this;
      this.$nextTick(() => {
        self.textValue = newValue;
        this.$emit('input', newValue);
      });
    },
    onBlur() {
      this.$emit('blur', this.textValue);
    },
  },
  created() {
    this.textValue = this.value;
  },
});
